import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';
import { INDUSTRIES, INDUSTRY_CATEGORIES } from '../data/industries';

const scrollToContact = () => { window.location.href = '/#contact'; };

export default function IndustriesIndexPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <WhatsAppButton />

      <section className="pt-36 pb-16 bg-slate-950 text-white relative overflow-hidden" data-testid="industries-hero">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(16,185,129,0.15),transparent_60%)]"></div>
        <div className="container mx-auto px-4 relative">
          <p className="text-emerald-400 text-sm font-semibold uppercase tracking-[0.25em] mb-4">
            <Link to="/" className="text-slate-400 hover:text-emerald-300">Home</Link> <span className="text-slate-600">/</span> Industries
          </p>
          <h1 className="text-4xl md:text-5xl font-bold leading-tight max-w-4xl mb-6">Sector Expertise That Shapes Better Funding</h1>
          <p className="text-lg text-slate-300 max-w-3xl leading-relaxed mb-8">
            Every industry has its own cash-flow rhythm, capex cycle and lender appetite. We structure funding around yours — across 30+ sectors, with real case studies behind every claim.
          </p>
          <Button onClick={scrollToContact} size="lg" className="bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-6 h-auto text-lg" data-testid="industries-cta">
            Get a Free Consultation <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </section>

      {INDUSTRY_CATEGORIES.map((cat) => {
        const items = Object.entries(INDUSTRIES).filter(([, v]) => v.category === cat);
        if (!items.length) return null;
        return (
          <section key={cat} className="py-14 bg-white border-t border-slate-100">
            <div className="container mx-auto px-4 max-w-6xl">
              <h2 className="text-2xl font-bold text-slate-900 mb-8">{cat}</h2>
              <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5">
                {items.map(([slug, v]) => (
                  <Link key={slug} to={`/industries/${slug}`} className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm hover:border-emerald-400 hover:shadow-md transition-all group" data-testid={`industry-card-${slug}`}>
                    <p className="font-bold text-lg text-slate-900 group-hover:text-emerald-700 mb-2">{v.name}</p>
                    <p className="text-sm text-slate-500 leading-relaxed line-clamp-2">{v.heroSub}</p>
                    <p className="text-xs text-emerald-600 mt-3 flex items-center gap-1 font-semibold">View sector solutions <ArrowRight className="w-3 h-3" /></p>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        );
      })}

      <section className="py-16 bg-slate-950 text-white text-center">
        <div className="container mx-auto px-4 max-w-3xl">
          <h2 className="text-3xl font-bold mb-4">Don't See Your Industry?</h2>
          <p className="text-slate-300 mb-8">We have arranged funding across dozens of sectors beyond this list. Speak to us about your specific requirement.</p>
          <Button onClick={scrollToContact} size="lg" className="bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-6 h-auto text-lg" data-testid="industries-cta-final">
            Talk to a Specialist <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
